import { useState } from "react";
import { apiFetch } from "../services/api.js";

export default function FormCriarCampanha({ onSuccess }) {
  const [nome, setNome] = useState("");
  const [prefixo, setPrefixo] = useState("");
  const [quantidadeMaxima, setQuantidadeMaxima] = useState(100);
  const [quantidadePremios, setQuantidadePremios] = useState(1);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [criando, setCriando] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setErro("");
    setSucesso("");
    setCriando(true);

    try {
      if (!nome.trim()) throw new Error("Nome obrigatorio");
      if (!prefixo.trim()) throw new Error("Prefixo obrigatorio");
      if (quantidadeMaxima < 1) throw new Error("Quantidade maxima invalida");

      const res = await apiFetch("campanhas", {
        method: "POST",
        body: JSON.stringify({
          nome,
          prefixo: prefixo.toUpperCase(),
          quantidade_maxima_cupons: quantidadeMaxima,
          quantidade_premios: quantidadePremios,
        }),
      });

      setSucesso(`Campanha "${nome}" criada com sucesso!`);
      setNome("");
      setPrefixo("");
      setQuantidadeMaxima(100);
      setQuantidadePremios(1);
      onSuccess && onSuccess();

      setTimeout(() => setSucesso(""), 4000);
    } catch (err) {
      setErro(err.message || "Erro ao criar campanha");
      console.error("[ERRO CAMPANHA]", err);
    } finally {
      setCriando(false);
    }
  }

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        padding: "1.5rem",
        backgroundColor: "#f9f9f9",
        borderRadius: "8px",
      }}
    >
      <h3>Criar Campanha</h3>

      <div>
        <label>Nome da Campanha:</label>
        <input
          value={nome}
          placeholder="Ex: Dia dos Pais, Black Friday"
          onChange={(e) => setNome(e.target.value)}
          disabled={criando}
          required
        />
      </div>

      <div>
        <label>Prefixo (unico):</label>
        <input
          value={prefixo}
          placeholder="Ex: DP, BF, NAT"
          maxLength="10"
          onChange={(e) => setPrefixo(e.target.value.toUpperCase())}
          disabled={criando}
          required
        />
        <small>Identifica os cupons: DP-001, DP-002, etc</small>
      </div>

      <div>
        <label>Quantidade maxima de cupons:</label>
        <input
          type="number"
          min="1"
          max="10000"
          value={quantidadeMaxima}
          onChange={(e) => setQuantidadeMaxima(parseInt(e.target.value) || 100)}
          disabled={criando}
        />
      </div>

      <div>
        <label>Quantidade de premios:</label>
        <input
          type="number"
          min="1"
          max="1000"
          value={quantidadePremios}
          onChange={(e) => setQuantidadePremios(parseInt(e.target.value) || 1)}
          disabled={criando}
        />
      </div>

      <button type="submit" disabled={criando}>
        {criando ? "Criando..." : "Criar Campanha"}
      </button>

      {erro && <p className="error-message">{erro}</p>}
      {sucesso && (
        <p style={{ color: "#27ae60", fontWeight: "600", marginTop: "0.5rem" }}>
          {sucesso}
        </p>
      )}
    </form>
  );
}
